import React, { FC } from 'react';

interface OwnProps {
  id?: string;
  key?: string;
  onClick?: () => void | null;
}

export const DefaultValueIcon: FC<OwnProps> = ({ id, key, onClick }) => {
  return (
    <svg
      id={id}
      key={key}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'default'}
    >
      <g clipPath="url(#clip0_2596_36945)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 1.66319C1 1.29692 1.29692 1 1.66319 1C1.76167 1 1.85892 1.02193 1.94786 1.0642L6.8743 3.40548C7.10378 3.51454 7.25 3.74593 7.25 4C7.25 4.25407 7.10378 4.48546 6.8743 4.59452L1.94786 6.9358C1.85892 6.97807 1.76167 7 1.66319 7C1.29692 7 1 6.70308 1 6.33681V6.33444C1 6.24313 1.01879 6.15279 1.0552 6.06906L1.95479 4L1.0552 1.93094C1.01879 1.84721 1 1.75687 1 1.66556V1.66319ZM9.5 13.5H4.75C3.23122 13.5 2 12.2688 2 10.75C2 9.23122 3.23122 8 4.75 8H11.25C12.2165 8 13 7.2165 13 6.25C13 5.2835 12.2165 4.5 11.25 4.5H9C8.72386 4.5 8.5 4.27614 8.5 4C8.5 3.72386 8.72386 3.5 9 3.5H11.25C12.7688 3.5 14 4.73122 14 6.25C14 7.76878 12.7688 9 11.25 9H4.75C3.7835 9 3 9.7835 3 10.75C3 11.7165 3.7835 12.5 4.75 12.5H9.5C9.77614 12.5 10 12.7239 10 13C10 13.2761 9.77614 13.5 9.5 13.5ZM14.146 10.6109C14.3412 10.4157 14.6578 10.4157 14.8531 10.6109C15.0483 10.8062 15.0483 11.1228 14.8531 11.318L13.4391 12.7321L14.8535 14.1465C15.0488 14.3417 15.0488 14.6583 14.8535 14.8536C14.6582 15.0488 14.3416 15.0488 14.1464 14.8536L12.732 13.4392L11.3175 14.8536C11.1223 15.0488 10.8057 15.0488 10.6104 14.8536C10.4152 14.6583 10.4152 14.3417 10.6104 14.1465L12.0249 12.7321L10.6108 11.3181C10.4156 11.1228 10.4156 10.8062 10.6108 10.6109C10.8061 10.4157 11.1227 10.4157 11.318 10.6109L12.732 12.0249L14.146 10.6109Z"
          fill="#FF8404"
        />
      </g>
      <defs>
        <clipPath id="clip0_2596_36945">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
